import apiPaths from '../config/apiPaths';
import { MetricResult, MetricsHistoryOverview } from '../modules/Monitoring/model/WeeklyStatisticsResponse';
import axiosInstance from './axios';

export const getActivityMetrics = (): Promise<MetricResult[]> =>
  axiosInstance.get<MetricResult[]>(apiPaths.ACTIVITY_METRICS).then(({ data }) => data);

export const getMetricsHistory = (): Promise<MetricsHistoryOverview> =>
  axiosInstance.get<MetricsHistoryOverview>(apiPaths.ACTIVITY_METRICS_HISTORY).then(({ data }) => data);
